import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 6H8V2H2v16h16V6zm2-2v16H0V0h10v4h10zM6.473 10.493l1.576-.228a.757.757 0 00.569-.414l.704-1.429a.747.747 0 01.678-.42c.27 0 .539.14.678.42l.704 1.429a.759.759 0 00.57.414l1.575.228c.62.09.868.852.419 1.29l-1.14 1.11a.754.754 0 00-.217.67l.269 1.568a.759.759 0 01-.745.886.753.753 0 01-.352-.088l-1.409-.741a.754.754 0 00-.704 0l-1.409.74a.753.753 0 01-.352.09.759.759 0 01-.745-.887l.269-1.568a.754.754 0 00-.217-.67l-1.14-1.11a.756.756 0 01.419-1.29z",
  fillRule: "evenodd"
});

var DirectoryFavoriteIcon = function DirectoryFavoriteIcon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
DirectoryFavoriteIcon.defaultProps = {
  size: 1.5
};
export default DirectoryFavoriteIcon;